import { signUp } from '../auth/asyncThunks';
import { fetchVendorInfo } from '../vendor/asyncThunks';

export const signUpBuilder = builder => {
  builder.addCase(signUp.fulfilled, (state, action) => {
    const { vendor } = action.payload;

    if (!vendor.onboardingFinishedAt) {
      state.name = vendor.name ? vendor.name : '';
      if (vendor.vendorCategory) {
        state.vendorCategory = vendor.vendorCategory;
        state.disableCategory = true;
      }
      if (vendor.phoneNumber) {
        state.phoneNumber = { value: vendor.phoneNumber, formattedValue: vendor.phoneNumber };
      }
      state.address = vendor.address ? vendor.address : '';
    }
  });
};

export const fetchVendorInfoBuilder = builder => {
  builder.addCase(fetchVendorInfo.pending, state => {
    state.gettingVendorInfo = true;
  });
  builder.addCase(fetchVendorInfo.fulfilled, (state, action) => {
    state.gettingVendorInfo = false;
    const { name, address, onboardingFinishedAt, phoneNumber, vendorCategory } = action.payload;

    if (!onboardingFinishedAt) {
      state.name = name;
      state.vendorCategory = vendorCategory;
      if (vendorCategory) {
        state.disableCategory = true;
      }
      state.phoneNumber = { value: phoneNumber, formattedValue: phoneNumber };
      state.address = address;
    }
  });
};
